import liveSessionService from '../../../services/livesession/LiveSessionService';

function checkInRange(name, a, min, max) {
    if (typeof a === 'number') {
        if (a >= min && a <= max) {
            return;
        }
        throw new Error(
            `${name} is not in [${min}, ${max}] range.`
        );
    } else {
        throw new Error(
            `${name} is not a number.`
        );
    }
}

class CallMediaConstraintsStatic {
    constructor() {
        this.videoWidth = null;
        this.videoHeight = null;
        this.videoFrameRate = null;
        this.audioChannelCount = null;
        this.audioSampleRate = null;
        this.audioGoogleEnhancements = null;
    }

    copy() {
        const constraintsCopy = new CallMediaConstraintsStatic();

        constraintsCopy.videoWidth = this.videoWidth;
        constraintsCopy.videoHeight = this.videoHeight;
        constraintsCopy.videoFrameRate = this.videoFrameRate;
        constraintsCopy.audioChannelCount = this.audioChannelCount;
        constraintsCopy.audioSampleRate = this.audioSampleRate;
        constraintsCopy.audioGoogleEnhancements = this.audioGoogleEnhancements;

        return constraintsCopy;
    }

    check() {
        checkInRange('videoWidth', this.videoWidth, 360, 1920);
        checkInRange('videoHeight', this.videoHeight, 180, 1440);
        checkInRange('videoFrameRate', this.videoFrameRate, 1, 30);
        checkInRange('audioChannelCount', this.audioChannelCount, 1, 2);
        checkInRange('audioSampleRate', this.audioSampleRate, 8000, 48000);

        if (typeof this.audioGoogleEnhancements !== 'boolean') {
            throw new Error(
                'audioGoogleEnhancements is not a boolean.'
            );
        }
    }

    video() {
        this.check();

        return {
            width: this.videoWidth,
            height: this.videoHeight,
            frameRate: this.videoFrameRate,
            facingMode: 'user',
        };
    }

    audio() {
        this.check();

        const audioEnhancements = liveSessionService.getAudioEnhancements();
        const constraints = {
            channelCount: this.audioChannelCount,
            sampleRate: this.audioSampleRate,
            ...audioEnhancements,
        };

        return constraints;
    }
}

export default CallMediaConstraintsStatic;
